<div class="check-email-wrapper">
    <div>
        <button type="button" class="back-button" (click)="onBackClick()">
            <i class="bi bi-chevron-left"></i>
            {{ 'FORGOT_PASSWORD.BACK' | translate }}
        </button>
        <div class="check-email-content">
            <h1 class="check-email-title">{{ 'FORGOT_PASSWORD.CHECK_EMAIL_TITLE' | translate }}</h1>
            <p class="check-email-message">{{ 'FORGOT_PASSWORD.CHECK_EMAIL_MESSAGE' | translate }}</p>

            <div class="resend-section">
                <p class="didnt-receive">{{ 'FORGOT_PASSWORD.DIDNT_RECEIVE' | translate }}</p>
                <div class="resend-wrapper">
                    <button type="button" class="resend-link" [class.disabled]="!canResend" [disabled]="!canResend"
                        (click)="onResendClick()">
                        {{ 'FORGOT_PASSWORD.CLICK_TO_RESEND' | translate }}
                    </button>
                    <span class="countdown" *ngIf="!canResend">{{ getCountdownDisplay() }}</span>
                </div>
            </div>
        </div>

    </div>
</div>